import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { Button, Form, FormGroup, Label, Input, Alert, FormFeedback } from 'reactstrap';
import classnames from 'classnames';

import DateTime from 'react-datetime';
import moment from 'moment';

import { incomeSlab } from '../../helpers/income_slab';
import { occupationList } from '../../helpers/occupation_list';
import { politicalExposureList } from '../../helpers/political_exposure_list';

import { ButtonWithLoader } from '../../../core';

class MiscDetailsForm extends Component {
  constructor(props) {
    super(props);

    if(props && props.data) {
      this.state = {
        errors: {},
        ...props.data
      }
    } else {
      this.state = {
        errors: {}
      };
    }

    this.submitMiscDetails = this.submitMiscDetails.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps && nextProps.data) {
      this.setState({
        ...nextProps.data
      })
    }
  }

  submitMiscDetails(e) {
    e.preventDefault();

    this.submit(false);
  }

  submit(shouldMoveNext) {
    
    let nominee  = this.state.nominee;
    let nomineeRelationShip = this.state.nomineeRelationShip;

    if (!this.state.martialStatus || !this.state.income || !this.state.occupation
        || !this.state.politicallyExposed ||
        (this.state.wantNominee === "yes" && (!nominee || !nomineeRelationShip))) {

      let errors = this.state.errors
      if (!this.state.martialStatus) {
        errors['martialStatus'] = "please select your martial status"
      }
      if (!this.state.income) {
        errors['perCountry'] = "please select your income"
      }
      if (!this.state.occupation) {
        errors['occupation'] = "please select your occupation"
      }
      if (!this.state.politicallyExposed) {
        errors['politicallyExposed'] = "are you politically exposed? please select your status"
      }

      if (!nominee) {
        errors["nominee"] = "Please enter nominee details"
      }

      if (!nomineeRelationShip) {
        errors["nomineeRelationShip"] = "Please select nominee relationship"
      }

      this.setState({
        errors: errors,
        submitting: false
      })
    }
    else {
      this.setState({
        errors: {},
        submitting: false
      });
      var personalDetails = {
        martialStatus: this.state.martialStatus,
        income: this.state.income,
        occupation: this.state.occupation,
        politicallyExposed: this.state.politicallyExposed,
        interestedinSip: "",
        mandateAmount: "",
        otherCountryName: "",
        pan: this.props.pan,
        nominee: this.state.nominee,
        nomineeRelationShip: this.state.nomineeRelationShip,
        dob: this.props.dob ? moment(this.props.dob).format("DD/MM/YYYY") : "01/01/1900",
      }
      
      this.props.submit('misc', personalDetails, shouldMoveNext);
    }
  }

  render() {
    return (
      <Form className="login-form" onSubmit={this.submitMiscDetails}>
        <FormGroup>
          <Label for="income"
            className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.income })} >
            Income
          </Label>

          <select className="custom-select border-bottom border-1 form-control"
            id="income"
            name="income"
            value={this.state.income}
            onChange={e => this.setState({ income: e.target.value })}
          >
            <option value="" key="none">Income</option>
            {incomeSlab.map(income => (
              <option value={income.name.toUpperCase()} key={income.name}>{income.name}</option>
            ))}
          </select>
          <FormFeedback className={classnames('d-block',{ invisible: (!this.state.errors.income || this.state.errors.income.length === 0) })}>
              {this.state.errors.income}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="occupation"
            className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.occupation })} >
            Occupation
          </Label>

          <select className="custom-select border-bottom border-1 form-control"
            id="occupation"
            name="occupation"
            value={this.state.occupation}
            onChange={e => this.setState({ occupation: e.target.value })}
          >
            <option value="" key="none">Occupation</option>
            {occupationList.map(occupation => (
              <option value={occupation.name.toUpperCase()} key={occupation.name}>{occupation.name}</option>
            ))}
          </select>
          <FormFeedback className={classnames('d-block',{ invisible: (!this.state.errors.occupation || this.state.errors.occupation.length === 0) })}>
              {this.state.errors.occupation}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="pol"
            className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.politicallyExposed })} >
            Politically exposed?
          </Label>

          <select className="custom-select border-bottom border-1 form-control"
            id="pol"
            name="pol"
            value={this.state.politicallyExposed}
            onChange={e => this.setState({ politicallyExposed: e.target.value })}
          >
            <option value="" key="none">Politically exposed?</option>
            {politicalExposureList.map(polex => (
              <option value={polex.name} key={polex.name}>{polex.name}</option>
            ))}
          </select>
          <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.politicallyExposed || this.state.errors.politicallyExposed.length === 0) })}>
            {this.state.errors.politicallyExposed}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="martialStatus"
            className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.martialStatus })} >
            Marital Status
          </Label>

          <select className="custom-select border-bottom border-1 form-control"
            id="martialStatus"
            name="martialStatus"
            value={this.state.martialStatus}
            onChange={e => this.setState({ martialStatus: e.target.value })}
          >
            <option value="" key="none">Marital Status</option>
            <option value="Married" key="married">Married</option>
            <option value="Unmarried" key="unmarried">Unmarried</option>
          </select>

          <FormFeedback className={classnames('d-block',{ invisible: (!this.state.errors.martialStatus || this.state.errors.martialStatus.length === 0) })}>
              {this.state.errors.martialStatus}
          </FormFeedback>
        </FormGroup>

        {/* <FormGroup>
          <Label for="martialStatus"
            className={classnames('text-muted', 'font-size-tiny')} >
            Would you like to add a nominee for your mutual fund investments?
          </Label>

          <select className="custom-select border-bottom border-1 form-control"
            id="wantNominee"
            name="wantNominee"
            value={this.state.wantNominee}
            onChange={e => this.setState({ wantNominee: e.target.value })}
          >
            <option value="yes" key="yes">Yes</option>
            <option value="no" key="no" selected>No</option>
          </select>

          <FormFeedback className={classnames('d-block',{ invisible: (!this.state.errors.wantNominee || this.state.errors.wantNominee.length === 0) })}>
              {this.state.errors.wantNominee}
          </FormFeedback>
        </FormGroup> */}

        { this.state.wantNominee ==="yes" ?
          <>
          <FormGroup>
            <Label for="name"
              className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.nominee })} >
              Nominee Name
            </Label>

            <Input type="text"
              name="nominee"
              id="nominee"
              className="form-control font-weight-semi-bold"
              placeholder="Nominee Name"
              onChange={e => this.setState({ nominee: e.target.value })}
              value={this.state.nominee}
              invalid={this.state.errors.nominee}
            />
            <FormFeedback className={classnames({ invisible: (!this.state.errors.nominee || this.state.errors.nominee.length === 0) })}>
              {this.state.errors.nominee}
            </FormFeedback>
          </FormGroup>

          <FormGroup>
            <Label for="martialStatus"
              className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.nomineeRelationShip })} >
              Nominee Relationship
            </Label>

            <select className="custom-select border-bottom border-1 form-control"
              id="nomineeRelationship"
              name="nomineeRelationship"
              value={this.state.nomineeRelationShip}
              onChange={e => this.setState({ nomineeRelationShip: e.target.value })}
            >
              <option value="" key="none">Nominee Relationship</option>
              <option value="Father" key="Father">Father</option>
              <option value="Mothers" key="Mother">Mother</option>
              <option value="Spouse" key="Spouse">Spouse</option>
              <option value="Son" key="Son">Son</option>
              <option value="Daughter" key="Daughter">Daughter</option>
              <option value="Brother" key="Brother">Brother</option>
              <option value="Sister" key="Sister">Sister</option>
            </select>

            <FormFeedback className={classnames('d-block', { invisible: (!this.state.errors.nomineeRelationShip || this.state.errors.nomineeRelationShip.length === 0) })}>
              {this.state.errors.nomineeRelationShip}
            </FormFeedback>
          </FormGroup>
          </>
          :
          ""
        }
        <FormGroup className="cta-block">
          {/* <ButtonWithLoader
              text="Save"
              isLoading={this.state.submitting}
              color="primary"
              className="w-100 mb-3"
              /> */}

          <ButtonWithLoader 
                text="Submit" 
                isLoading={this.state.submitting} 
                className="w-100 btn-outline-dark"
                onClick={() => this.submit(true)}
                />
        </FormGroup>
      </Form>
    );
  }
}

export default MiscDetailsForm; 